import {
  ADMIN_ROLE,
  ADVERTISER_ROLE,
  DESIGNER_ROLE,
  MARKETER_ROLE,
  OWNER_ROLE,
  SUPER_ADMIN_ROLE,
  VIEWER_ROLE,
} from "../../../utils/constants";
import {
  getRolePriority,
  sortUsersByRolePriority as sortUsersByRoleOrder,
} from "./loginAsUsers.js";

/**
 * Platform/shop role order used by the send-email modal.
 * Most important first (aligned with ROLES_PLATFORMS + remaining ROLES_SHOPS).
 * Unknown roles sort after these, then by name/email.
 */
const ROLE_ORDER_LIST = [
  ADVERTISER_ROLE,
  MARKETER_ROLE,
  VIEWER_ROLE,
  OWNER_ROLE,
  DESIGNER_ROLE,
  SUPER_ADMIN_ROLE,
  ADMIN_ROLE,
];

/**
 * @param {Array<{ role?: string, name?: string, email?: string }>} users
 * @param {string[]} [roleOrderList]
 * @returns {Array<typeof users[number]>}
 */
export const sortUsersByRolePriority = (
  users,
  roleOrderList = ROLE_ORDER_LIST
) => sortUsersByRoleOrder(users, roleOrderList);

/**
 * Merge users from multiple advertisers under an agency; dedupe by email (case-insensitive),
 * keeping the user with the highest role priority when duplicates exist.
 * @param {{ advertisers?: Array<{ advertiser?: { users?: unknown[] } }> }} agencyGroup
 */
export const mergeUsersForAgencyEmail = (agencyGroup) => {
  const advertisers = agencyGroup?.advertisers;
  if (!Array.isArray(advertisers)) return [];

  const byEmail = new Map();

  for (const item of advertisers) {
    const users = item?.advertiser?.users;
    if (!Array.isArray(users)) continue;
    for (const u of users) {
      if (!u?.email || typeof u.email !== "string") continue;
      const key = u.email.trim().toLowerCase();
      if (!key) continue;
      const existing = byEmail.get(key);
      if (
        !existing ||
        getRolePriority(u.role, ROLE_ORDER_LIST) <
          getRolePriority(existing.role, ROLE_ORDER_LIST)
      ) {
        byEmail.set(key, u);
      }
    }
  }

  return sortUsersByRolePriority([...byEmail.values()]);
};
